import { createTranslations } from '@npco/common-utils-translations'

export const contactTransferModalTranslations = createTranslations({
  primaryButtonLabel: 'Pay Now',
  from: 'From',
  accountNumber: 'Account Number',
  to: 'To',
  accountName: 'Account Name',
  bsb: 'BSB',
  description: 'Description',
  reference: 'Reference',
  transferDetails: 'Transfer Details',
  transferErrorMessage: 'Your transfer was unsuccessful. Please try again.',
  maxDailyLimit:
    "This amount exceeds your Daily Maximum Limit. Please contact Zeller Support if you'd like to raise your limit.",
  deFallbackMessage:
    "We weren't able to confirm your recipient's bank details, please check your transfer details to ensure they're correct before proceeding.",
  recipientDetails: 'Recipient Details',
})
